/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */


/**
 * Enum pour les Urls
 * @readonly
 * @enum { string }  PathsNamesEnums
 */
export enum CSS {
  /** @type {string} */
  TUNNELGREEN = '#00E1B3',
  BLACK = '#000000',
  BLUECOLOR = '#007ADF',
  WHITE = '#ffffff',
  GREY = 'whiteSmoke',
  DARKGREY = '#979797',
  COLOR = '#4DA1FF',
  BORDERCOLOR = '#E9EFF4',
  BORDERCOLORTUNNEL = '#007ADF',
  BORDER_RADIUS = '.2em',
  PADDING = '20px',
  MODAL = 'rgba(0, 0, 0, 0.25)',

}


// WEBPACK FOOTER //
// ./src/apps/tunnel/enums/styled/index.ts